import Scene = Phaser.Scene;
import Container = Phaser.GameObjects.Container;
import {UpdateListener} from "@/utils/update-listener";
import ListenerManager from "@/managers/listener-manager";
import Sprite = Phaser.GameObjects.Sprite;
import {Keys} from "@/constants/key";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";

export class ListView extends Container implements UpdateListener {

    private mainContainer!: Container;

    private speed: number = 0;
    private minY!: number;
    private lastY!: number;
    private listViewPressed: boolean = false;

    private scrollPressed: boolean = false;
    private lastScrollY!: number;

    private scrollMaxY!: number;
    private scroll!: Sprite;

    private background!: Phaser.GameObjects.Rectangle;

    constructor(scene: Scene, canvas: HTMLCanvasElement, children: Container[], x: number, y: number, zoneWidth: number, zoneHeight: number) {
        super(scene);
        this.scene = scene;
        this.x = x;
        this.y = y;
        ListenerManager.addUpdateListener(this);

        this.mainContainer = new Container(scene);
        this.mainContainer.setPosition(0, 0);

        const self = this;

        let background = this.scene.add.rectangle(0, 0, zoneWidth, zoneHeight).setOrigin(0, 0).setInteractive();
        this.add(background);
        this.background = background;

        let width = children[0].width;
        let height = 0;
        for (let c of children) {
            height += c.height * CU.S;
        }

        this.width = width;
        this.height = height;

        this.minY = zoneHeight - height;

        background.on('pointerdown', function (pointer: any) {
            if (height > zoneHeight) {
                self.listViewPressed = true;
                self.lastY = pointer.y;
            }
        });

        this.scene.input.on('pointerup', () => {
            self.listViewPressed = false;
            self.scrollPressed = false;
        });

        this.scene.input.on('gameobjectwheel', function(pointer: any, gameObject: any, dx: any, dy: any, dz: any, event: any) {
            if (self.height + 10 > gameObject.height) {
                self.speed += (dy > 0 ? -4 : 4);
            }
        });

        let pos = 0;
        for (let c of children) {
            c.x = (zoneWidth - c.width) / 2;
            c.y = pos;
            pos += c.height * CU.S;
            this.mainContainer.add(c);
        }

        let graphics = scene.make.graphics({}, false);
        graphics.fillRect(x, y, zoneWidth, zoneHeight);
        let mask = new Phaser.Display.Masks.GeometryMask(scene, graphics);
        graphics.setVisible(false);
        this.add([graphics]);
        this.setMask(mask);

        let scrollHeight = Math.min(zoneHeight, zoneHeight * zoneHeight / height)
        this.scrollMaxY = zoneHeight - scrollHeight;
        this.scroll = SpriteUtils.addSprite(this.scene, zoneWidth / CU.S, 0, Keys.ATLAS_UI, Keys.UI_SCROLL).setOrigin(1, 0).setInteractive();
        SpriteUtils.setDispSize(this.scroll, 10, scrollHeight);
        if (scrollHeight >= zoneHeight) {
            this.scroll.setVisible(false);
        } else {
            this.scroll.on('pointerdown', function (pointer: any) {
                self.lastScrollY = pointer.y;
                self.listViewPressed = false;
                self.speed = 0;
                self.scrollPressed = true;
            });
            this.scene.input.on('pointermove', function (pointer: any) {
                if (self.scrollPressed) {
                    self.scroll.y += (pointer.y - self.lastScrollY);
                    self.scroll.y = Math.max(0, self.scroll.y);
                    self.scroll.y = Math.min(self.scrollMaxY, self.scroll.y);
                    self.lastScrollY = pointer.y;
                    self.mainContainer.y = self.scroll.y * self.minY / self.scrollMaxY;
                }
            });
        }

        this.add(this.mainContainer);
        this.add(this.scroll);
    }

    public getBackground(): Phaser.GameObjects.Rectangle {
        return this.background;
    }

    update(): void {
        if (!this.active) {
            ListenerManager.removeUpdateListener(this);
            return;
        }
        if (this.listViewPressed) {
            let pointerY = this.scene.game.input.activePointer.y;
            this.speed = (pointerY - this.lastY);
            this.lastY = pointerY;
        } else {
            this.speed *= 0.99;
            if (Math.abs(this.speed) < 1) {
                this.speed = 0;
            }
        }

        if (this.speed != 0) {
            this.mainContainer.y += this.speed;
            this.mainContainer.y = Math.min(0, this.mainContainer.y);
            this.mainContainer.y = Math.max(this.minY, this.mainContainer.y);

            this.scroll.y = this.scrollMaxY * this.mainContainer.y / this.minY;

            if (this.mainContainer.y >= 0 || this.mainContainer.y <= this.minY) {
                this.speed = 0;
            }
        }
    }

}
